import React from 'react';
import { LangConsumer } from 'utils/LangProvider';
import { Tabs } from 'libs';
import CompleteConfigure from '../IVSConfig/CompleteConfigure';
import RuleConfig from '../IVSConfig/RuleConfig';
import './index.less';
import { bindLifecycle } from 'utils/bindLifecycle';
import pubsub from 'utils/pubsub';
import plugin from 'plugin';
import WebApp from '../../../webapp';
const { TabPane } = Tabs;
const sceneType = 'FishDetection';

class FishDetectionComponent extends React.Component {
    /**用来存放组件内状态 */
    constructor (props) {
        super(props);
        this.ComponentName = 'FishDetection';
        this.RuleConfig = React.createRef();

        this.state = {
            key: '1', // 当前显示的tab也key值
            showGlobalPage: true // 是否显示全局配置页面
        };
    }

    /**此时获取异步数据 */
    componentDidMount () {
        let {pageChannels} = this.props;
        this.getGlobalPage();
        this.pubAndSub();
    }
    componentDidActivate () {
        let key = this.state.key;
        this.setState({
            key:''
        },() => {
            this.setState({
                key
            });
        });
        this.pubAndSub();
    }
    componentWillUnactivate () {
        this.unSub();
    }
    componentWillUnmount () {
        this.unSub();
    }
    // 订阅videoToggle事件
    pubAndSub = () => {
        //集成版本 首次由于keepalive首次会同时触发componentDidMount 和 componentDidActivate, 导致订阅无法注销
        pubsub.unsubscribe(this.pid_pre);
        this.pid_pre = pubsub.subscribe('videoToggle', data => {
            let { key } = this.state;
            if (plugin.playMode === 'ocx') {
                if (data) {
                    plugin.hide();
                } else {
                    if (key === '1') {
                        this.RuleConfig.current.reOpenPlugin();
                    } else if (key === '2') {
                        this.CompleteConfigure.reOpenPlugin();
                    }
                }
            }
        });
    }
    // 取消订阅
    unSub = () => {
        pubsub.unsubscribe(this.pid_pre);
    }
    //判断全局配置是否显示
    getGlobalPage = () => {
        let {showGlobalPage} = this.state;
        let globalConfigChannel = [];
        //所有通道都不支持时隐藏全局配置，只要有一个通道支持就要显示全局配置tab
        if (WebApp.ChannelCapsInfo) {
            for (let chn = 0; chn < WebApp.ChannelCapsInfo.length; chn++) {
                let caps = WebApp.ChannelCapsInfo[chn];
                if (caps && caps.SupportedScenes && caps.SupportedScenes[sceneType] && caps.SupportedScenes[sceneType].SupportedCalibrateParams && caps.SupportedScenes[sceneType].SupportedCalibrateParams.MaxCelibateAreas !== 0) {
                    globalConfigChannel.push(chn);
                }
            }
        }
        if (globalConfigChannel.length > 0) {
            showGlobalPage = true;
        } else {
            showGlobalPage = false;
        }
        this.setState({
            showGlobalPage
        });
    }
    changeTab = (key) => {
        if (key === '2') { // 切换的时候插件要关闭或者打开
            this.RuleConfig.current.closePlugin();
            if (this.CompleteConfigure) {
                this.CompleteConfigure.reOpenPlugin();
            }
        } else {
            this.RuleConfig.current.reOpenPlugin();
            this.RuleConfig.current.refresh(true);
            if (this.CompleteConfigure) {
                this.CompleteConfigure.closePlugin();
            }
        }
        this.setState({key});
    }
    render () {
        let {$t, preStep, isShowNext, nextStep, pageChannels, keepAlive, choosePlanType, currentPlanID, presetValueArr, notLinkageChanArrInMultiComp, currentMode, singleSDRuleData, realPlanType} = this.props;
        let {key, showGlobalPage} = this.state;
        const wrapNextStep = function () {// 主入口页面封装下, 子组件直接调用
            nextStep('FishDetection');
        };
        return (
            <div className = '_FishDetection_'>
                <Tabs activeKey={key} onTabClick={this.changeTab}>
                    <TabPane tab={$t('ivs.RuleConfig')} key="1">
                        <RuleConfig
                            ref={this.RuleConfig}
                            tabKey={key}
                            {...{preStep, isShowNext, nextStep, pageChannels, keepAlive, choosePlanType, currentPlanID, presetValueArr, notLinkageChanArrInMultiComp, singleSDRuleData, realPlanType}}
                            changeChanel={this.changeChannel}
                            currentMode={currentMode}
                            ClassType={sceneType}
                        />
                    </TabPane>
                    {showGlobalPage ?
                        <TabPane tab={$t('com.CompleteConfigure')} key="2">
                            <CompleteConfigure
                                {...{preStep, isShowNext, wrapNextStep, pageChannels, keepAlive, choosePlanType, currentPlanID, presetValueArr, notLinkageChanArrInMultiComp, singleSDRuleData, realPlanType}}
                                tabKey={key}
                                wrappedComponentRef={(form) => this.CompleteConfigure = form}
                                ClassType={sceneType}/>
                        </TabPane> :
                        ''
                    }
                </Tabs>
            </div>
        );
    }
}

export default LangConsumer(bindLifecycle(FishDetectionComponent));
